/* istanbul ignore file */
/**
 * Created by rathompson on 5/9/22
 * File: DeviceReducer.actions
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// Action Types
export const LOAD_DEVICES = 'LOAD_DEVICES'
export const LOAD_CSP_DEVICES = 'LOAD_DEVICES'

export const loadDevices = (devices = []) => ({
  type: LOAD_DEVICES,
  devices
})

export const loadCSPDevices = (cspDevices = []) => ({
  type: LOAD_CSP_DEVICES,
  cspDevices
})
